<template>
  <div>
    <prozess-search-dropdown
      v-model="data"
      :placeholder="$t(placeHolder)"
      :loading="loading"
      :new-item-message="$t('Add as new')"
      :can-handle-new-item="false"
      :options="items"
      icon="Share2Icon"
      :error="error"
      :hint="hint"
      :disabled="disabled || !entityType"
      @search="handleSearch"
      @clear="handleClear"
      @blur="handleBlur"
    />
  </div>
</template>

<script>
import documentService from '@/services/document'
import { getSchemaName } from '@/helpers/apiHelper'

export default {
  props: {
    label: {
      default: null,
      type: String,
    },
    value: {
      default: null,
      type: [String, Number, Object],
    },
    hint: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    entityType: {
      type: String,
      default: null,
    },
    placeHolder: {
      type: String,
      default: 'Search',
    },
  },
  data() {
    return {
      data: this.value,
      items: [],
      contactSearch: '',
      loading: false,
    }
  },
  watch: {
    data() {
      this.$emit('input', this.data)
    },
    value(data) {
      this.data = data
    },
  },
  methods: {
    handleClear() {
      this.items = []
      this.$emit('input', null)
    },
    handleBlur() {
      this.items = []
    },
    handleSearch(search) {
      if (search.trim().length < 3) return
      this.loading = true

      documentService.autocomplete(getSchemaName(this.entityType), this.entityType, search.trim())
        .then(res => {
          this.items = res.data.map(item => ({
            label: item.name || `${item.firstName || ''} ${item.lastName}`,
            // selectedLabel: item.name || `${item.firstName} ${item.lastName}`,
            // additionalLabels: ['completeAddress'],
            value: item,
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
